export default class ConsultationReportWrittenQuestion {
  constructor(key, issue, answer = "") {
    this.key = key;
    this.issue = issue;
    this.answer = answer;
  }
}